import { LinearProgress } from "@mui/material";
import React from "react";

const Processing = ({ show = false, title = "Processing..." }) => {
  return (
    <div className={`${show ? "" : "hidden"}`}>
      <div className="bg-white p-6 rounded-2xl shadow-lg max-w-md mx-auto border border-gray-100 transform transition-all duration-300 hover:scale-105">
        <div className="flex items-center space-x-3">
          {/* Animated Spinner */}
          <svg
            className="h-5 w-5 text-primary animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>

          {/* Text */}
          <span className="text-sm font-medium text-gray-700">{title}</span>
        </div>

        {/* Progress Bar */}
        <div className="mt-4">
          <LinearProgress
            className="rounded-full h-2 p-[4px]"
            sx={{
              backgroundColor: "#E5E7EB",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Processing;
